/*
  Leuchtvolley · Produktseite (sections/lv-main-product.liquid)

  Ein Skript für alles, was die Produktseite bewegt:
    1. Galerie (Scroll-Snap, Pfeile, Thumbnails, Wischen), ohne Zoom
    2. Kaching-Pakete: Auswahl, Zusatzzeilen, Spar-Zeile, 15-Minuten-Timer
    3. Warenkorb: EIN /cart/add.js-Request für Ball + Zusatzprodukte,
       danach Dawns cart-drawer.renderContents (öffnet den Drawer)
    4. Fenster „Größe & Details" (<dialog>)
    5. Akkordeons (exklusiv, sanft)
    6. Mini-Bewertungen (endlos, Wischen)
    7. Sticky-ATC (erscheint, sobald der Haupt-Button oben raus ist)
    8. Kaching-Preis: Preis oben = erstes Kaching-Paket (auch im A/B-Test), Sticky-Leiste = gewähltes Paket

  Absprache mit dem Warenkorb (KACHING-CART-REFERENZ §4):
    sessionStorage "lv_protection_optout" = "1" (plus Altname "lv-protection-off")
    heißt: Kunde will in dieser Sitzung keine Shipping Protection.
    pubsub cartUpdate mit source "product-form".
*/
(function () {
  'use strict';

  if (window.LvProduct) return;

  var OPTOUT_KEYS = ['lv_protection_optout', 'lv-protection-off'];
  var DEADLINE_KEY = 'lv-bundle-deadline';
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      if (value === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
    return null;
  }

  function isOptedOut() {
    if (window.LvCart && typeof window.LvCart.isProtectionOff === 'function') {
      try {
        if (window.LvCart.isProtectionOff()) return true;
      } catch (e) {}
    }
    return OPTOUT_KEYS.some(function (key) {
      return store(key) === '1';
    });
  }

  function setOptOut(off) {
    OPTOUT_KEYS.forEach(function (key) {
      store(key, off ? '1' : null);
    });
    if (window.LvCart && typeof window.LvCart.setProtectionOff === 'function') {
      try {
        window.LvCart.setProtectionOff(!!off);
      } catch (e) {}
    }
  }

  function routes() {
    var r = window.routes || {};
    return {
      add: (r.cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js',
      cart: r.cart_url || '/cart'
    };
  }

  function behavior() {
    return reduceMotion.matches ? 'auto' : 'smooth';
  }

  /* Text aus einem data-Attribut mit HTML-Entities (z. B. &nbsp;) als reinen Text lesen. */
  function decodeText(value) {
    var box = document.createElement('textarea');
    box.innerHTML = value;
    return box.value;
  }

  /* Spar-Badge: Vorlage aus data-format (Übersetzung lv.product.save_badge_html, Platzhalter __PCT__),
     sonst wie bisher Präfix + Prozent. */
  function badgeText(el, pct) {
    var format = el.getAttribute('data-format');
    if (format) return decodeText(format.split('__PCT__').join(String(pct)));
    return (el.getAttribute('data-prefix') || 'SPARE') + ' ' + pct + '\u00a0%';
  }

  /* ------------------------------------------------------------------
     1. Galerie
     ------------------------------------------------------------------ */
  function initGallery(root) {
    var gallery = root.querySelector('[data-lv-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-lv-gal-track]');
    if (!track) return;
    var slides = toArray(track.children);
    var thumbs = toArray(gallery.querySelectorAll('[data-lv-gal-goto]'));
    var thumbList = gallery.querySelector('[data-lv-gal-thumbs]');
    var current = 0;
    var lockUntil = 0;
    var frame = null;

    function mark(index) {
      current = index;
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var active = thumbs[index];
      if (active && thumbList) {
        var item = active.parentElement;
        var left = item.offsetLeft - thumbList.offsetLeft;
        var right = left + item.offsetWidth;
        if (left < thumbList.scrollLeft) {
          thumbList.scrollTo({ left: Math.max(0, left - 4), behavior: behavior() });
        } else if (right > thumbList.scrollLeft + thumbList.clientWidth) {
          thumbList.scrollTo({ left: right - thumbList.clientWidth + 4, behavior: behavior() });
        }
      }
    }

    function go(index, instant) {
      if (!slides.length) return;
      var next = (index + slides.length) % slides.length;
      var jump = instant || Math.abs(next - current) > 1;
      lockUntil = Date.now() + (jump ? 120 : 500);
      track.scrollTo({ left: next * track.clientWidth, behavior: jump ? 'auto' : behavior() });
      mark(next);
    }

    track.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          if (Date.now() < lockUntil) return;
          var width = track.clientWidth || 1;
          var index = Math.round(track.scrollLeft / width);
          if (index !== current && index >= 0 && index < slides.length) mark(index);
        });
      },
      { passive: true }
    );

    var prev = gallery.querySelector('[data-lv-gal-prev]');
    var next = gallery.querySelector('[data-lv-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        go(parseInt(thumb.getAttribute('data-lv-gal-goto'), 10) || 0, true);
      });
    });

    window.addEventListener('resize', function () {
      track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
    });

    root.lvGalleryGo = go;
  }

  /* ------------------------------------------------------------------
     2. Pakete
     ------------------------------------------------------------------ */
  function cardsOf(root) {
    return toArray(root.querySelectorAll('[data-lv-bu-card]'));
  }

  function activeCard(root) {
    var cards = cardsOf(root);
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].classList.contains('lv-bu__card--on')) return cards[i];
    }
    return null;
  }

  function labelOf(root, btn, key) {
    var main = root.querySelector('[data-lv-atc]');
    if (key === 'label') return btn.getAttribute('data-label') || (main && main.getAttribute('data-label')) || '';
    return (main && main.getAttribute('data-label-' + key)) || '';
  }

  function setLabel(btn, text) {
    var label = btn.querySelector('[data-lv-atc-label]');
    if (label && text) label.textContent = text;
  }

  function setAtcState(root, card) {
    var available = !card || card.getAttribute('data-available') === 'true';
    buttonsOf(root).forEach(function (btn) {
      if (btn.classList.contains('is-loading')) return;
      btn.disabled = !available;
      setLabel(btn, available ? labelOf(root, btn, 'label') : labelOf(root, btn, 'soldout'));
    });
  }

  function updateSummary(root, card) {
    var bundles = root.querySelector('[data-lv-bundles]');
    if (bundles && card) {
      var wrap = bundles.querySelector('[data-lv-bu-save-wrap]');
      var out = bundles.querySelector('[data-lv-bu-save]');
      var save = card.getAttribute('data-save') || '';
      if (wrap) wrap.hidden = !save;
      if (out && save) out.textContent = save;
    }

    /* Preis oben folgt dem gewählten Paket */
    if (card) {
      var nowEl = root.querySelector('[data-lv-price-now]');
      var wasEl = root.querySelector('[data-lv-price-was]');
      if (nowEl) nowEl.textContent = card.getAttribute('data-price') || nowEl.textContent;
      if (wasEl) {
        var was = card.getAttribute('data-compare') || '';
        wasEl.textContent = was;
        wasEl.hidden = !was;
      }
      var pBadge = root.querySelector('[data-lv-price-badge]');
      if (pBadge) {
        var pPct = parseInt(card.getAttribute('data-pct'), 10) || 0;
        pBadge.hidden = pPct <= 0;
        pBadge.textContent = badgeText(pBadge, pPct);
      }
    }

    var sticky = root.querySelector('[data-lv-sticky]');
    if (sticky && card) {
      var pkg = sticky.querySelector('[data-lv-st-pkg]');
      var price = sticky.querySelector('[data-lv-st-price]');
      var compare = sticky.querySelector('[data-lv-st-compare]');
      var badge = sticky.querySelector('[data-lv-st-badge]');
      var pct = parseInt(card.getAttribute('data-pct'), 10) || 0;
      if (pkg) pkg.textContent = card.getAttribute('data-title') || '';
      if (price) price.textContent = card.getAttribute('data-price') || '';
      if (compare) {
        var cmp = card.getAttribute('data-compare') || '';
        compare.textContent = cmp;
        compare.hidden = !cmp;
      }
      if (badge) {
        badge.hidden = pct <= 0;
        badge.textContent = badgeText(badge, pct);
      }
    }
  }

  function selectCard(root, card, fromUser) {
    if (!card || card.classList.contains('lv-bu__card--off')) return;
    cardsOf(root).forEach(function (c) {
      c.classList.toggle('lv-bu__card--on', c === card);
    });
    var radio = card.querySelector('[data-lv-bu-radio]');
    if (radio && !radio.checked) radio.checked = true;
    updateSummary(root, card);
    setAtcState(root, card);

    if (fromUser && typeof root.lvGalleryGo === 'function') {
      var media = parseInt(card.getAttribute('data-media'), 10);
      if (media >= 0) root.lvGalleryGo(media, true);
    }
  }

  function initTimer(root) {
    var pill = root.querySelector('[data-lv-bu-timer]');
    if (!pill) return;
    var text = pill.querySelector('[data-lv-bu-timer-text]');
    var out = pill.querySelector('[data-lv-bu-time]');
    var minutes = parseInt(pill.getAttribute('data-minutes'), 10) || 15;
    var end = parseInt(store(DEADLINE_KEY), 10);
    if (!end || end <= Date.now()) {
      end = Date.now() + minutes * 60 * 1000;
      store(DEADLINE_KEY, String(end));
    }
    var timer = null;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left <= 0) {
        if (text) text.textContent = pill.getAttribute('data-end-text') || '';
        if (timer) window.clearInterval(timer);
        return;
      }
      var total = Math.floor(left / 1000);
      if (out) out.textContent = pad(Math.floor(total / 60)) + ':' + pad(total % 60);
    }

    tick();
    timer = window.setInterval(tick, 1000);
  }

  function initBundles(root) {
    var bundles = root.querySelector('[data-lv-bundles]');
    var cards = cardsOf(root);
    if (!bundles || !cards.length) return;

    /* Abwahl der Protection aus einer früheren Seite übernehmen. */
    if (isOptedOut()) {
      toArray(bundles.querySelectorAll('[data-optout-row] input[type="checkbox"]')).forEach(function (cb) {
        cb.checked = false;
      });
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('[data-lv-bu-radio]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) selectCard(root, card, true);
        });
      }

      toArray(card.querySelectorAll('[data-lv-addon]')).forEach(function (row) {
        row.addEventListener('click', function (event) {
          /* Zeile eines anderen Pakets: nur das Paket wählen, Häkchen bleibt. */
          if (!card.classList.contains('lv-bu__card--on')) {
            event.preventDefault();
            selectCard(root, card, true);
            return;
          }
          if (row.getAttribute('data-locked') === 'true') event.preventDefault();
        });

        var cb = row.querySelector('input[type="checkbox"]');
        if (cb && row.getAttribute('data-kind') === 'protection' && row.getAttribute('data-locked') !== 'true') {
          cb.addEventListener('change', function () {
            setOptOut(!cb.checked);
            /* Alle bezahlten Protection-Zeilen gleich halten. */
            toArray(bundles.querySelectorAll('[data-optout-row] input[type="checkbox"]')).forEach(function (other) {
              other.checked = cb.checked;
            });
          });
        }
      });
    });

    var start = activeCard(root) || cards[0];
    selectCard(root, start, false);
    initTimer(root);
  }

  /* ------------------------------------------------------------------
     3. Warenkorb
     ------------------------------------------------------------------ */
  function buttonsOf(root) {
    return toArray(root.querySelectorAll('[data-lv-atc], [data-lv-sticky-btn]'));
  }

  function setLoading(root, on, done) {
    buttonsOf(root).forEach(function (btn) {
      btn.classList.toggle('is-loading', on);
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) {
        btn.disabled = true;
        setLabel(btn, labelOf(root, btn, 'busy'));
      }
    });
    if (on) return;
    setAtcState(root, activeCard(root));
    if (!done) return;
    buttonsOf(root).forEach(function (btn) {
      if (!btn.disabled) setLabel(btn, labelOf(root, btn, 'done'));
    });
    window.clearTimeout(root.lvDoneTimer);
    root.lvDoneTimer = window.setTimeout(function () {
      setAtcState(root, activeCard(root));
    }, 1800);
  }

  function showError(root, message) {
    var box = root.querySelector('[data-lv-error]');
    var main = root.querySelector('[data-lv-atc]');
    var fallback = (main && main.getAttribute('data-error')) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
    if (!box) {
      window.alert(message || fallback);
      return;
    }
    var text = box.querySelector('[data-lv-error-text]');
    if (text) text.textContent = message || fallback;
    box.hidden = false;
    var rect = box.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      box.scrollIntoView({ behavior: behavior(), block: 'center' });
    }
  }

  function clearError(root) {
    var box = root.querySelector('[data-lv-error]');
    if (box) box.hidden = true;
  }

  function getCart() {
    if (window.LvCart && window.LvCart.last && window.LvCart.last.items) {
      return Promise.resolve(window.LvCart.last);
    }
    return fetch(routes().cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function buildItems(root, form) {
    var card = activeCard(root);
    var protIntent = null;
    var list = [];

    if (card) {
      list.push({
        id: parseInt(card.getAttribute('data-variant'), 10),
        quantity: parseInt(card.getAttribute('data-qty'), 10) || 1,
        kind: 'ball'
      });
      toArray(card.querySelectorAll('[data-lv-addon]')).forEach(function (row) {
        var cb = row.querySelector('input[type="checkbox"]');
        var locked = row.getAttribute('data-locked') === 'true';
        var on = locked || (cb && cb.checked);
        var kind = row.getAttribute('data-kind');
        if (kind === 'protection') protIntent = protIntent === true ? true : !!on;
        var id = parseInt(row.getAttribute('data-variant-id'), 10);
        if (on && id) list.push({ id: id, quantity: 1, kind: kind, free: locked });
      });
    } else if (form) {
      var data = new FormData(form);
      list.push({
        id: parseInt(data.get('id'), 10),
        quantity: parseInt(data.get('quantity'), 10) || 1,
        kind: 'ball'
      });
    }

    return { list: list, protIntent: protIntent };
  }

  function mergeItems(list) {
    var map = {};
    var out = [];
    list.forEach(function (item) {
      if (!item.id) return;
      if (map[item.id]) {
        map[item.id].quantity += item.quantity;
      } else {
        map[item.id] = { id: item.id, quantity: item.quantity };
        out.push(map[item.id]);
      }
    });
    return out;
  }

  function drawerEl() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.renderContents === 'function' ? drawer : null;
  }

  function post(items) {
    var drawer = drawerEl();
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) {
        return s.section || s.id;
      });
      body.sections_url = window.location.pathname;
    }
    return fetch(routes().add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          return { ok: response.ok && !data.status, data: data };
        });
    });
  }

  function publishUpdate(items, data) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: items[0] && items[0].id,
          cartData: data
        });
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('lv:cart:added', { detail: { items: items, cart: data } }));
    } catch (e) {}
  }

  function openDrawer(data) {
    var drawer = drawerEl();
    if (!drawer) {
      window.location.href = routes().cart;
      return Promise.resolve();
    }
    var render = function (payload) {
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
      drawer.classList.remove('is-empty');
      drawer.renderContents(payload);
    };
    if (data && data.sections && data.sections['cart-drawer']) {
      try {
        render(data);
        return Promise.resolve();
      } catch (e) {}
    }
    var ids = drawer.getSectionsToRender().map(function (s) {
      return s.section || s.id;
    });
    return fetch(routes().cart + '?sections=' + encodeURIComponent(ids.join(',')), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        render({ sections: sections });
      })
      .catch(function () {
        window.location.href = routes().cart;
      });
  }

  function submit(root, form) {
    if (root.lvBusy) return;
    var built = buildItems(root, form);
    if (!built.list.length || !built.list[0].id) {
      showError(root);
      return;
    }

    /* Protection-Wunsch merken, bevor der Warenkorb-Abgleich anläuft. */
    if (built.protIntent === true) setOptOut(false);
    if (built.protIntent === false) setOptOut(true);

    root.lvBusy = true;
    clearError(root);
    setLoading(root, true);

    getCart()
      .then(function (cart) {
        var list = built.list;
        if (cart && cart.items && cart.items.length) {
          var protPid = parseInt((root.querySelector('[data-lv-bundles]') || root).getAttribute('data-prot-product-id'), 10) || 0;
          var protLines = cart.items.filter(function (line) {
            return protPid && line.product_id === protPid;
          });
          if (protLines.length) {
            /* Keine zweite Protection: gleiche Variante nie doppelt, bezahlte nie zusätzlich. */
            list = list.filter(function (item) {
              if (item.kind !== 'protection') return true;
              var same = protLines.some(function (line) {
                return line.variant_id === item.id;
              });
              if (same) return false;
              return item.free;
            });
          }
        }
        var items = mergeItems(list);
        var ball = mergeItems([built.list[0]]);

        return post(items).then(function (res) {
          if (res.ok) return { data: res.data, items: items };
          if (items.length < 2) throw res.data;
          /* Zubehör darf den Ballkauf nie blockieren: einmal nur mit Ball versuchen. */
          return getCartFresh().then(function (fresh) {
            var has =
              fresh &&
              fresh.items &&
              fresh.items.some(function (line) {
                return line.variant_id === ball[0].id;
              });
            if (has) return { data: null, items: ball };
            return post(ball).then(function (res2) {
              if (res2.ok) return { data: res2.data, items: ball };
              throw res2.data;
            });
          });
        });
      })
      .then(function (result) {
        root.lvBusy = false;
        setLoading(root, false, true);
        publishUpdate(result.items, result.data);
        return openDrawer(result.data);
      })
      .catch(function (err) {
        root.lvBusy = false;
        setLoading(root, false);
        var message = err && (err.description || err.message);
        if (typeof message !== 'string' || !message) message = '';
        showError(root, message);
      });
  }

  function getCartFresh() {
    return fetch(routes().cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  /* Kaching Bundles: Liegt das Kaching-Widget auf der Seite, bestimmt Kaching Menge, Varianten und Geschenke.
     Dann schicken wir das Formular so ab wie Dawn (FormData an /cart/add). Kaching greift genau diesen
     Request ab und schreibt seine Auswahl hinein. Danach oeffnet sich unser Warenkorb-Fenster. */
  function hasKaching(root) {
    return !!(
      root.querySelector('kaching-bundles-block, kaching-bundle, .kaching-bundles__block') ||
      document.querySelector('kaching-bundles-block')
    );
  }

  function submitKaching(root, form) {
    if (root.lvBusy) return;
    root.lvBusy = true;
    clearError(root);
    setLoading(root, true);
    var fd = new FormData(form);
    var drawer = drawerEl();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append(
        'sections',
        drawer
          .getSectionsToRender()
          .map(function (s) {
            return s.section || s.id;
          })
          .join(',')
      );
      fd.append('sections_url', window.location.pathname);
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '');
    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok || data.status) throw data;
            return data;
          });
      })
      .then(function (data) {
        root.lvBusy = false;
        setLoading(root, false, true);
        var vid = parseInt(fd.get('id'), 10) || 0;
        publishUpdate([{ id: vid }], data);
        return openDrawer(data);
      })
      .catch(function (err) {
        root.lvBusy = false;
        setLoading(root, false);
        var message = err && (err.description || err.message);
        if (typeof message !== 'string' || !message) message = '';
        showError(root, message);
      });
  }

  /* Button „Armbänder dazunehmen" (Bild-mit-Text, Link #lv-armband-bundle):
     2 Bälle über Kaching (Deal-Preis + Geschenk) + LED-Armbänder in den Warenkorb, dann Warenkorb öffnen.
     Alte Links auf #lv-bundles scrollen zum Kaching-Widget. */
  function sleep(ms) {
    return new Promise(function (r) {
      setTimeout(r, ms);
    });
  }

  function kachingBars() {
    var k = document.querySelector('kaching-bundles-block');
    return k ? Array.prototype.slice.call(k.querySelectorAll('.kaching-bundles__bar')) : [];
  }

  function pickTwoBar(bars) {
    for (var i = 0; i < bars.length; i++) {
      var t = (bars[i].innerText || '').replace(/\s+/g, ' ');
      if (/(^|\D)2(\s|\u00a0)*(B(ä|a)ll(e|s)|x|er|St|pcs|pieces)|(Kaufe|Buy) 2\b/i.test(t)) return bars[i];
    }
    return bars[1] || null;
  }

  function sectionIds() {
    var drawer = drawerEl();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) {
        return s.section || s.id;
      });
    }
    return [];
  }

  function addArmbandBundle(trigger) {
    var root = document.querySelector('[data-lv-product]');
    var form = root ? root.querySelector('[data-lv-form]') : null;
    if (!root || !form || root.lvBusy) return;
    root.lvBusy = true;
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    var armHandle = root.getAttribute('data-armband-handle') || 'led-armbaender';
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '');
    var bars = kachingBars();
    var two = pickTwoBar(bars);
    var ready = Promise.resolve();
    if (two) {
      two.click();
      ready = sleep(450);
    }
    ready
      .then(function () {
        var fd = new FormData(form);
        if (!two) fd.set('quantity', '2');
        return fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok || d.status) throw d;
            return d;
          });
        });
      })
      .then(function () {
        return fetch('/products/' + armHandle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.ok ? r.json() : null;
        });
      })
      .then(function (prod) {
        var v = null;
        if (prod && prod.variants) {
          for (var i = 0; i < prod.variants.length; i++) {
            if (prod.variants[i].available && prod.variants[i].price > 0) {
              v = prod.variants[i];
              break;
            }
          }
        }
        var body = { items: v ? [{ id: v.id, quantity: 1 }] : [], sections: sectionIds(), sections_url: window.location.pathname };
        if (!v) return null;
        return fetch(routes().add, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(function (r) {
          return r.json().catch(function () {
            return null;
          });
        });
      })
      .then(function (data) {
        root.lvBusy = false;
        if (trigger) trigger.removeAttribute('aria-busy');
        publishUpdate([{ id: 0 }], data);
        return openDrawer(data && data.sections ? data : null);
      })
      .catch(function (err) {
        root.lvBusy = false;
        if (trigger) trigger.removeAttribute('aria-busy');
        var message = err && (err.description || err.message);
        showError(root, typeof message === 'string' ? message : '');
      });
  }

  document.addEventListener('click', function (event) {
    var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/#lv-armband-bundle$/.test(href)) {
      event.preventDefault();
      addArmbandBundle(a);
      return;
    }
    if (/#lv-bundles$/.test(href) && !document.getElementById('lv-bundles')) {
      var target = document.querySelector('kaching-bundles-block') || document.querySelector('[data-lv-form]');
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: behavior(), block: 'center' });
      }
    }
  });

  /* Capture-Phase am document: läuft vor jedem anderen Submit-Listener (auch Dawns product-form). */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('[data-lv-form]')) return;
      var root = form.closest('[data-lv-product]');
      if (!root) return;
      event.preventDefault();
      event.stopPropagation();
      if (hasKaching(root) && !root.querySelector('[data-lv-bundles]')) {
        submitKaching(root, form);
        return;
      }
      submit(root, form);
    },
    true
  );

  /* ------------------------------------------------------------------
     4. Fenster „Größe & Details"
     ------------------------------------------------------------------ */
  function initModals(root) {
    toArray(root.querySelectorAll('[data-lv-dm-open]')).forEach(function (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-lv-dm-open'));
      if (!dialog || dialog.dataset.lvReady) return;
      dialog.dataset.lvReady = '1';

      function close() {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
        document.documentElement.classList.remove('lv-dm-open');
      }

      opener.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('lv-dm-open');
        var closeBtn = dialog.querySelector('[data-lv-dm-close]');
        if (closeBtn) closeBtn.focus();
      });

      toArray(dialog.querySelectorAll('[data-lv-dm-close]')).forEach(function (btn) {
        btn.addEventListener('click', close);
      });

      /* Klick daneben: trifft den Backdrop, also das <dialog> selbst. */
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var r = dialog.getBoundingClientRect();
        var inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
        if (!inside || event.clientX === 0) close();
      });

      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('lv-dm-open');
        opener.focus();
      });

      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && typeof dialog.showModal !== 'function') close();
      });
    });
  }

  /* ------------------------------------------------------------------
     5. Akkordeons
     ------------------------------------------------------------------ */
  function initAccordions(root) {
    var items = toArray(root.querySelectorAll('[data-lv-acc]'));
    if (!items.length) return;

    function animate(details, open) {
      var body = details.querySelector('.lv-acc__body');
      if (details.lvAnim) {
        details.lvAnim.cancel();
        details.lvAnim = null;
      }
      details.lvClosing = false;
      if (!body || reduceMotion.matches || typeof body.animate !== 'function') {
        details.open = open;
        return;
      }
      if (open) {
        var from = details.open ? body.offsetHeight : 0;
        details.open = true;
        details.lvAnim = body.animate(
          { height: [from + 'px', body.scrollHeight + 'px'] },
          { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' }
        );
        details.lvAnim.onfinish = function () {
          details.lvAnim = null;
        };
      } else {
        details.lvClosing = true;
        details.lvAnim = body.animate({ height: [body.offsetHeight + 'px', '0px'] }, { duration: 220, easing: 'ease' });
        details.lvAnim.onfinish = function () {
          details.open = false;
          details.lvClosing = false;
          details.lvAnim = null;
        };
      }
    }

    items.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.open && !details.lvClosing) {
          animate(details, false);
          return;
        }
        items.forEach(function (other) {
          if (other !== details && other.open && !other.lvClosing) animate(other, false);
        });
        animate(details, true);
      });
    });
  }

  /* ------------------------------------------------------------------
     6. Mini-Bewertungen
     ------------------------------------------------------------------ */
  function initMiniReviews(root) {
    toArray(root.querySelectorAll('[data-lv-mr]')).forEach(function (box) {
      var track = box.querySelector('[data-lv-mr-track]');
      if (!track) return;
      var count = track.children.length;
      var index = 0;
      if (count < 2) return;

      function render() {
        track.style.transform = 'translate3d(' + index * -100 + '%, 0, 0)';
        toArray(track.children).forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
      }

      function go(step) {
        index = (index + step + count) % count;
        render();
      }

      var prev = box.querySelector('[data-lv-mr-prev]');
      var next = box.querySelector('[data-lv-mr-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      var startX = null;
      var startY = null;
      track.addEventListener(
        'touchstart',
        function (event) {
          var t = event.touches[0];
          startX = t.clientX;
          startY = t.clientY;
        },
        { passive: true }
      );
      track.addEventListener(
        'touchend',
        function (event) {
          if (startX === null) return;
          var t = event.changedTouches[0];
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        },
        { passive: true }
      );

      render();
    });
  }

  /* ------------------------------------------------------------------
     7. Sticky-ATC
     ------------------------------------------------------------------ */
  function initSticky(root) {
    var sticky = root.querySelector('[data-lv-sticky]');
    var atc = root.querySelector('[data-lv-atc]');
    if (!sticky || !atc) return;
    var html = document.documentElement;
    var visible = null;

    function show(on) {
      if (on === visible) return;
      visible = on;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      var btn = sticky.querySelector('[data-lv-sticky-btn]');
      if (btn) btn.tabIndex = on ? 0 : -1;
      html.classList.toggle('lv-sticky-atc-on', on);
      /* Der Nach-oben-Button (lv-scroll-to-top) rutscht um diese Höhe nach oben (Checkliste A15). */
      if (on) html.style.setProperty('--lv-sticky-atc-height', sticky.offsetHeight + 'px');
      else html.style.removeProperty('--lv-sticky-atc-height');
    }

    /* Sichtbar, sobald der Haupt-Button komplett nach oben aus dem Bild gescrollt ist. */
    function check() {
      show(atc.getBoundingClientRect().bottom < 0);
    }

    var last = 0;
    window.addEventListener(
      'scroll',
      function () {
        var now = Date.now();
        if (now - last < 60) return;
        last = now;
        check();
      },
      { passive: true }
    );
    window.addEventListener('scroll', function () {
      window.clearTimeout(root.lvStickyTimer);
      root.lvStickyTimer = window.setTimeout(check, 90);
    }, { passive: true });
    window.addEventListener('resize', check);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(check, { threshold: 0 }).observe(atc);
    }
    check();
  }

  /* ------------------------------------------------------------------
     Sprung zu den Bewertungen
     ------------------------------------------------------------------ */
  function initReviewAnchor(root) {
    var link = root.querySelector('[data-lv-review-anchor]');
    if (!link) return;
    link.addEventListener('click', function (event) {
      var hash = (link.getAttribute('href') || '').split('#')[1];
      var target = hash ? document.getElementById(hash) : null;
      if (!target) target = document.querySelector('[data-lv-reviews], .lv-rb');
      if (!target) return;
      event.preventDefault();
      var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: behavior() });
    });
  }

  /* ------------------------------------------------------------------
     8. Kaching-Preis
     Der Preis oben zeigt den Preis des ersten Kaching-Pakets, die Sticky-Leiste den des gerade
     gewählten Pakets samt Kurzname („Kaufe 2“). So passt er
     auch dann zum Widget, wenn ein Kaching-A/B-Test andere Pakete ausspielt (z. B. kleinstes Paket
     = 2 Stück). Ohne Kaching-Widget bleibt der Preis aus Liquid stehen.
     Das Spar-Schild zeigt höchstens den normalen Rabatt des Produkts (z. B. immer 50 %, nie 63 %).
     ------------------------------------------------------------------ */
  function initKachingPrice(root) {
    if (root.querySelector('[data-lv-bundles]') || typeof MutationObserver !== 'function') return;
    var host = root.querySelector('kaching-bundle, kaching-bundles-block');
    if (!host) return;
    var baseBadge = root.querySelector('[data-lv-price-badge]');
    var basePct = baseBadge && !baseBadge.hidden ? parseInt((baseBadge.textContent || '').replace(/\D/g, ''), 10) || 0 : 0;

    function text(el) {
      return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }

    function cents(str) {
      var m = str.match(/\d[\d.,'\s]*/);
      if (!m) return 0;
      var raw = m[0].replace(/[\s']/g, '');
      var dec = raw.match(/[.,](\d{1,2})$/);
      var whole = dec ? raw.slice(0, raw.length - dec[0].length) : raw;
      return (parseInt(whole.replace(/\D/g, ''), 10) || 0) * 100 + (dec ? parseInt((dec[1] + '0').slice(0, 2), 10) : 0);
    }

    function put(el, value) {
      if (el && el.textContent !== value) el.textContent = value;
    }

    /* Kurzname fürs Sticky: Titel bis zur ersten Zahl („Kaufe 2 und erhalte 10% Rabatt“ → „Kaufe 2“) */
    function label(title) {
      var m = title.match(/^\D*\d+/);
      if (m && /[^\d\s]/.test(m[0])) return m[0].trim();
      return title.split(' ').slice(0, 2).join(' ');
    }

    function read(bar) {
      if (!bar) return null;
      var now = text(bar.querySelector('.kaching-bundles__bar-price'));
      var nowCents = cents(now);
      if (!nowCents) return null;
      var was = text(bar.querySelector('.kaching-bundles__bar-full-price'));
      var wasCents = cents(was);
      if (wasCents <= nowCents) was = '';
      var pct = was ? Math.round(((wasCents - nowCents) * 100) / wasCents) : 0;
      if (basePct > 0 && pct > basePct) pct = basePct;
      return { now: now, was: was, pct: pct, label: label(text(bar.querySelector('.kaching-bundles__bar-title'))) };
    }

    function apply() {
      /* Preis oben: erstes Paket */
      var first = read(host.querySelector('.kaching-bundles__bar'));
      if (!first) return;
      put(root.querySelector('[data-lv-price-now]'), first.now);
      var wasEl = root.querySelector('[data-lv-price-was]');
      if (wasEl) {
        put(wasEl, first.was);
        wasEl.hidden = !first.was;
      }
      var badge = root.querySelector('[data-lv-price-badge]');
      if (badge) {
        badge.hidden = first.pct <= 0;
        if (first.pct > 0) put(badge, badgeText(badge, first.pct));
      }

      /* Sticky-Leiste: das gerade gewählte Paket (das legt ihr Button in den Warenkorb) */
      var checked = host.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
      var picked = (checked && read(checked.closest('.kaching-bundles__bar'))) || first;
      put(root.querySelector('[data-lv-st-pkg]'), picked.label);
      put(root.querySelector('[data-lv-st-price]'), picked.now);
      var stWas = root.querySelector('[data-lv-st-compare]');
      if (stWas) {
        put(stWas, picked.was);
        stWas.hidden = !picked.was;
      }
    }

    new MutationObserver(apply).observe(host, { childList: true, subtree: true, characterData: true, attributes: true });
    host.addEventListener('change', apply);
    apply();
  }

  /* ------------------------------------------------------------------
     Start
     ------------------------------------------------------------------ */
  function init(root) {
    if (!root || root.dataset.lvReady === '1') return;
    root.dataset.lvReady = '1';
    initGallery(root);
    initBundles(root);
    initModals(root);
    initAccordions(root);
    initMiniReviews(root);
    initSticky(root);
    initReviewAnchor(root);
    initKachingPrice(root);
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-lv-product]')).forEach(init);
  }

  window.LvProduct = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    toArray(document.querySelectorAll('[data-lv-product]')).forEach(function (root) {
      root.lvBusy = false;
      setLoading(root, false);
    });
  });
})();
